import { contextFactory } from '@frontend/design-system';

export type QuickFillTrayContextType = {
  closeModal: () => void;
};

export const [QuickFillTrayContext, useQuickFillTrayContext] = contextFactory<QuickFillTrayContextType>();
